import { useContext, useEffect, useState } from "react";
import dayjs from "dayjs";
import State from "../../../../../../context";
import { Button, Flex, Skeleton } from "antd";
import SecurityGate from "../../../../../../provider/SecurityGate";

import StylesContainer from "../../../admin/page/PageMarketing/style";

import { getEquippingFiles } from "../../request";

import { FolderOpenOutlined, LeftOutlined } from "@ant-design/icons";
import Folder from "../../../../../../image/icon/Folder";
import { ReactComponent as File } from "../../../../../../image/icon/file.svg";

const PageEquipping = () => {
  const [state] = useContext(State);
  const [historyList, setHistoryList] = useState([]);
  const [activeFolderData, setActiveFolderData] = useState();
  const [loading, setLoading] = useState(false);

  const searchParams = new URLSearchParams(window.location.search);

  const handleBack = () => {
    updateFiles(historyList.at(-2));
    setHistoryList(lastState => lastState.slice(0, -1));
  };

  useEffect(() => {
    updateFiles();
  }, []);

  const updateFiles = folderId => {
    setLoading(true);

    getEquippingFiles({
      folderId,
      userEmail: decodeURIComponent(searchParams.get("email")?.toLowerCase()),
    })
      .then(setActiveFolderData)
      .catch(state.showError)
      .finally(() => setLoading(false));
  };

  const onClickFile = url => {
    window.open(url);
  };

  const onClickFolder = folderId => {
    setHistoryList(lastState => [...lastState, folderId]);

    updateFiles(folderId);
  };

  return (
    <SecurityGate state={state}>
      <StylesContainer>
        <header>
          <h4>Equipping</h4>
        </header>

        <p>
          <b>THE CONTENTS OF THIS FOLDER ARE FOR INTERNAL USE ONLY!</b> It
          exists to provide OAF and OAW affiliated advisors with information
          that will equip them to be well-informed and confident in their
          interactions and communications with clients as it relates to
          OneAscent Investments and values-based investing.
        </p>

        <Flex
          gap={16}
          style={{
            paddingBottom: 8,
            borderBottom: `1px solid #E7EBEE`,
            marginBottom: 24,
          }}
        >
          {!!historyList?.length && (
            <>
              <Button
                type="text"
                size="small"
                shape="round"
                icon={<LeftOutlined />}
                onClick={handleBack}
              >
                Back
              </Button>
              <FolderOpenOutlined style={{ fontSize: 26 }} />
            </>
          )}
        </Flex>

        <Skeleton active loading={loading}>
          <Flex gap={16} wrap>
            {activeFolderData?.map(it =>
              it.folder ? (
                <Flex
                  align="center"
                  gap={4}
                  key={it.id}
                  style={{ width: 127, textAlign: "center", cursor: "pointer" }}
                  onClick={() => onClickFolder(it.id)}
                  vertical
                >
                  <Folder />
                  <span style={{ fontWeight: 500 }}>{it.name}</span>
                  <span style={{ fontSize: 12 }}>
                    {dayjs(it.createdDateTime).format("MM/DD/YYYY")}
                  </span>
                </Flex>
              ) : (
                <Flex
                  gap={20}
                  key={it.id}
                  style={{ width: 240, cursor: "pointer" }}
                  onClick={() =>
                    onClickFile(it["@microsoft.graph.downloadUrl"])
                  }
                >
                  <File style={{ minWidth: 40 }} />
                  <Flex gap={6} vertical>
                    <span style={{ fontWeight: 500 }}>{it.name}</span>
                    <span>
                      {dayjs(it.createdDateTime).format("MM/DD/YYYY")}
                    </span>
                  </Flex>
                </Flex>
              )
            )}
          </Flex>
        </Skeleton>
      </StylesContainer>
    </SecurityGate>
  );
};

export default PageEquipping;
